<template lang="pug">
  div
    v-row
      v-col(
        v-for="shop in shops",
        :key="shop.id",
        sm="4",
      )
        v-checkbox(        
          v-model="currentValue",
          :value="shop.id",
          :label='shop.name',
          :error="$attrs['error-messages'] !== undefined",
        )
    .subtitle.error--text {{ $attrs['error-messages'] }}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      shops: 'shop/items',
    }),

    currentValue: {
      get: function() {
        return this.value;
      },

      set: function(updatedValue) {
        this.$emit('update:value', updatedValue);
      },
    },
  },

  created() {
    this.$store.dispatch('shop/fetch');
  },
};
</script>
